import { Component, OnInit } from '@angular/core';
import { TitleService } from '@core/services/title.service';
import { Subscription } from 'rxjs';

import { AppService } from '@app/services/app/app.service';
/**
 * 
 * Main manage users component,
 * show Users and Seats in unique screen
 *
 */
@Component({
    selector: 'settings-manage-users',
    templateUrl: './manage-users.component.html',
    styleUrls: ['./manage-users.component.scss']
})
export class SettingsManageUsersComponent implements OnInit{

    private readonly ACCESS = 'access_setting_users_access';

	public loaded: boolean = false;
    public access: boolean = false;

    // public licensed: boolean = false;

    protected session: any = null;

    protected appSusbcriber: Subscription; 

	constructor(private app: AppService, private title: TitleService){}

	ngOnInit(){
        this.title.set("Users - System settings");

        this.appSusbcriber = this.app.getSession().subscribe( (session: any) => {
            this.session = session;
            this.access = this.session.options.access.hasOwnProperty(this.ACCESS)? this.session.options.access[this.ACCESS] : false;
            this.loaded = true;
        });
	}

}
